export const COMPANY_TITLE = 'Hezardastan';
export const COMPANY_ID = 1;
export const DOMAIN_URL = 'https://careers.hezardastan.ir';
// we use a shared workable account for all companies
export const API_URL = 'https://hezardastan.recrupen.com/api/';
